import { useId, type ReactNode } from 'react';

export interface BaseSectionProps {
  title: ReactNode;
  titleId?: string;
  extra?: ReactNode;
  children?: ReactNode;
  variant?: 'section' | 'summary' | 'plain';
}

/** 统一详情分区标题和对象摘要，数据、徽标及正文由调用方提供。 */
export default function BaseSection({
  title,
  titleId,
  extra,
  children,
  variant = 'section',
}: BaseSectionProps) {
  const generatedId = useId();
  const id = titleId ?? generatedId;
  const Heading = variant === 'summary' ? 'h2' : 'h3';
  const headerClassName =
    variant === 'section'
      ? 'px-3 py-1.5 border border-solid border-[var(--muou-section-border)] border-l-[3px] border-l-[var(--muou-section-accent)] rounded bg-[var(--muou-section-bg)] text-[var(--muou-section-text)] text-[13px] leading-[18px]'
      : '';
  const headingClassName =
    variant === 'summary'
      ? 'text-text text-[22px] leading-[28px]'
      : variant === 'plain'
      ? 'flex-1 text-text text-[13px] leading-5'
      : '[font-size:inherit] leading-[inherit]';
  return (
    <section
      className={`base-section min-w-0 base-section-${variant}`}
      aria-labelledby={id}
    >
      <div
        className={`base-section-header flex items-center gap-2 ${headerClassName}`}
      >
        <Heading
          id={id}
          className={`min-w-0 m-0 font-semibold [overflow-wrap:anywhere] ${headingClassName}`}
        >
          {title}
        </Heading>
        {extra}
      </div>
      {children !== undefined && (
        <div
          className={`base-section-body ${
            variant === 'plain' ? 'mt-2' : 'mt-3'
          }`}
        >
          {children}
        </div>
      )}
    </section>
  );
}
